// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__KAqBv","radioLabel":"Radio_radioLabel__gmuuF"};